import React from 'react';
const nav = [{
  label: 'Catalog',
  href: '#catalog'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Authors',
  href: '#authors'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-paper border-t border-white/10" data-id="element-112" data-mp="32p5mwh8vcypb">
      <div className="mx-auto max-w-6xl px-6 py-14 grid sm:grid-cols-2 gap-10" data-id="element-113" data-mp="36oxw8w6378vq">
        <div data-id="element-114" data-mp="3ufa3s5xf73ls">
          <p className="font-serif text-2xl" data-id="element-115" data-mp="3ueimm04kl8f1">Deleon Publishing LLC</p>
          <p className="text-paper/55 text-sm mt-3 max-w-xs leading-relaxed" data-id="element-116" data-mp="3ud7ddkscv8gj">
            An independent press dedicated to works of history, philosophy, and
            the spirit.
          </p>
        </div>
        <nav className="sm:text-right" aria-label="Footer" data-id="element-117" data-mp="3qdf7jfucjgev">
          <ul className="flex flex-wrap sm:justify-end gap-x-8 gap-y-3" data-id="element-118" data-mp="3qblvtm4vm600">
            {nav.map(n => <li key={n.href} data-id="element-119" data-mp="29xvqkc20tbos">
                <a href={n.href} className="text-paper/70 hover:text-gold-light transition-colors text-sm tracking-wide" data-id="element-120" data-mp="2ey0907mhoghn">
                  {n.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10" data-id="element-121" data-mp="3v7q79tbr8rhm">
        <div className="mx-auto max-w-6xl px-6 py-6 flex flex-col sm:flex-row justify-between gap-2 text-paper/45 text-xs" data-id="element-122" data-mp="3v8hpm2gccspy">
          <p data-id="element-123" data-mp="3qapyvbrfncnc">© {new Date().getFullYear()} Deleon Publishing LLC. All rights reserved.</p>
          <p data-id="element-124" data-mp="817c224r7iry">Made with care, one book at a time.</p>
        </div>
      </div>
    </footer>;
}